import classes from './loading.module.css';

const Loading = () => (
  <div className={classes.loading}>
    <div className={classes.loader} />
  </div>
);

export default Loading;
